import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export function login(cellphone, linkedAccount) {
  return new Promise((resolve, reject) => {
    authToken()
      .then((token) => {
        axios
          .post(
            cfac22('API_HOST_V2') + '/login',
            {
              cellphone,
              linkedAccount,
            },
            {
              headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
            }
          )
          .then((result) => {
            //console.log('RESULTADO LOGIN ===>', result);
            resolve(result);
          })
          .catch((error) => {
            //console.log('ERROR LOGIN ===>', error);
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
